/**
 * Created by ddxfc on 2017/8/18.
 */
import Vue from 'vue';
import Router from 'vue-router';
import PageLoginIndex from '@/components/pages/login/PageLoginIndex.vue';
import store from '../stores';
import injection from '../lib/installer';

Vue.use(Router);

const router =  new Router({
    routes: [
        {
            path: '/',
            name: 'loginIndex',
            component: PageLoginIndex
        },
        {
            path: '/forget',
            name: 'forget',
            component: () => import('@/components/pages/login/PageForget.vue')
        },
        {
            path: '/update',
            name: 'update',
            component: () => import('@/components/pages/login/PageForget.vue')
        },
        {
            path: '*',
            redirect: '/'
        },
    ]
});

router.beforeEach((to, from, next) => {
    if (store.state.appUrls.wx_appid) {
        next();
        return;
    }
    store.commit('appConfig', window.__APP__CONFIG);
    injection.api(injection.config.apiUrl.appUrls).then(res => {
        store.commit('appUrls', res);
        next();
    }).catch(() => {
        injection.$alias.error('获取站点url信息失败');
    });
});

export default router;
